import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const BookingStartStep: React.FC = () => {
  const { goNext } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.tidsbestilling.bk_start).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);
  return (
    <StepContainer title="Tidsbestilling">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <NavigationButtons onNext={goNext} showBack={false} nextText="Start" />
    </StepContainer>
  );
};

export default BookingStartStep;
